import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, Lock, ArrowLeft, Loader2, CheckCircle2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { esqueciSenha, redefinirSenha } from '../lib/api';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_delivery-desk-12/artifacts/76spvmi3_3D4A54DE-AC29-47B8-ABEA-5150F325A161.png';

const Moldura = ({ children }) => (
  <div className="min-h-screen flex flex-col items-center p-6 sm:p-10 bg-white">
    <div className="w-full max-w-md">
      <Link to="/login" className="flex items-center text-sm text-slate-500 hover:text-[#2A5BC7] mb-8">
        <ArrowLeft className="w-4 h-4 mr-1" /> Voltar para o login
      </Link>
      <img src={LOGO_URL} alt="In'Nova Envios" className="h-16 mb-8" />
      {children}
    </div>
  </div>
);

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const { toast } = useToast();

  const enviar = async (e) => {
    e.preventDefault();
    if (!email) { toast({ title: 'Informe seu e-mail' }); return; }
    setLoading(true);
    try {
      await esqueciSenha(email.trim());
      setEnviado(true);
    } catch (err) {
      toast({ title: 'Não foi possível enviar', description: err?.response?.data?.detail || 'Confira o e-mail e tente novamente.' });
    } finally { setLoading(false); }
  };

  return (
    <Moldura>
      {enviado ? (
        <div>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mb-4" />
          <h1 className="text-2xl font-extrabold text-slate-900">Confira seu e-mail</h1>
          <p className="mt-3 text-slate-600">Se <b>{email}</b> estiver cadastrado, enviamos um link para criar uma nova senha. Ele vale por 1 hora. Se não chegar em alguns minutos, olhe a caixa de spam.</p>
          <p className="mt-4 text-sm text-slate-500">Criou a conta com o Google? Funciona do mesmo jeito: você define uma senha e passa a poder entrar com e-mail e senha também.</p>
        </div>
      ) : (
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900">Esqueci minha senha</h1>
          <p className="mt-2 text-slate-600">Informe o e-mail da sua conta e enviamos um link para criar uma nova senha.</p>
          <form onSubmit={enviar} className="mt-6 space-y-5">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <div className="relative mt-1.5">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input id="email" type="email" placeholder="voce@email.com" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9 h-11" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full inn-btn-primary h-12 rounded-full">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Enviando...</> : 'Enviar link'}
            </Button>
          </form>
        </div>
      )}
    </Moldura>
  );
};

export default ForgotPasswordPage;
